import { render, staticRenderFns } from "./SecretaryAssignmentMessageSection.vue?vue&type=template&id=140bcae4&scoped=true&"
import script from "./SecretaryAssignmentMessageSection.vue?vue&type=script&lang=js&"
export * from "./SecretaryAssignmentMessageSection.vue?vue&type=script&lang=js&"
import style0 from "./SecretaryAssignmentMessageSection.vue?vue&type=style&index=0&id=140bcae4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140bcae4",
  null
  
)

export default component.exports